export default {
      id: "ic-misc-accessibility-usage",
      viewBox: "0 0 29.7 27.2",
      url: "../dist/images/" + "sprite.svg#ic-misc-accessibility-usage",
      toString: function () {
        return this.url;
      }
    }